import React, { useState } from 'react';
import HTMLParsedContent from '../HTMLParsedContent';
import {
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  List,
  NumericItem,
  OrderCount,
  SectionTitleItemListWrapper,
  SectionWrapper,
} from './styles';

import CheckMarkIcon from '../../../styles/svgs/check-mark.svg';
import ArrowRightIcon from '../../../styles/svgs/arrow-right.svg';

export type SectionTitleItemListProps = {
  contentOrientation: 'column' | 'row';
  backgroundColor: 'lightGradient' | 'white';
  listType: 'accordion' | 'numeric';
  text: string;
  items: ListItems[];
};

interface ListItems {
  title: string;
  text: string;
}

const SectionTitleItemList: React.FC<SectionTitleItemListProps> = ({
  contentOrientation,
  listType,
  text,
  items,
}) => {
  const [clicked, setClicked] = useState<number | null>(0);
  const handleToggleAccordion = (index: number) => {
    setClicked(clicked === index ? null : index);
  };

  return (
    <SectionWrapper>
      <SectionTitleItemListWrapper contentOrientation={contentOrientation}>
        <HTMLParsedContent content={text} className="rich-text text" />
        {listType === 'accordion' && (
          <List className="list" listType={listType} contentOrientation={contentOrientation}>
            {items.map((item, index) => (
              <AccordionItem key={item.title} clicked={clicked} index={index}>
                <AccordionButton onClick={() => handleToggleAccordion(index)}>
                  <div className="title-wrapper">
                    <CheckMarkIcon />
                    <p style={{ fontWeight: 700 }}>{item.title}</p>
                  </div>

                  <ArrowRightIcon className="arrow-icon" />
                </AccordionButton>
                <AccordionPanel
                  style={clicked === index ? { maxHeight: '600px' } : { maxHeight: 0 }}
                >
                  {item.text ? (
                    <HTMLParsedContent className="text" content={item.text} />
                  ) : (
                    <div style={{ height: 0 }}></div>
                  )}
                </AccordionPanel>
              </AccordionItem>
            ))}
          </List>
        )}
        {listType === 'numeric' && (
          <List listType={listType} contentOrientation={contentOrientation}>
            {items.map((item, index) => (
              <NumericItem key={item.title}>
                <OrderCount>
                  <div className="numeric-circle">
                    <p>{index + 1}</p>
                  </div>
                  {index + 1 !== items.length && <div className="vertical-line"></div>}
                </OrderCount>
                <div className="content">
                  <h3 className="title">{item.title}</h3>
                  <HTMLParsedContent className="text" content={item.text} />
                </div>
              </NumericItem>
            ))}
          </List>
        )}
      </SectionTitleItemListWrapper>
    </SectionWrapper>
  );
};

export default SectionTitleItemList;
